import type { ReactNode } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import styles from "./Layout.module.css";

type LayoutPropsType = {
  children: ReactNode;
};

const Layout = ({ children }: LayoutPropsType) => {
  return (
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.main}> {children}</main>
    </div>
  );
};

export default Layout;
